import { Icon } from "@iconify/react";
import useWindowDimensions from "../../../components/hook/use.window.dimensions";
import { useNavigate } from "react-router-dom";
import { DatePicker } from "antd";
import { useState } from "react";
import dayjs from "dayjs";
import Button from "../../../components/element/button";
import {
  setActivePage,
  setDate,
  setSearch,
} from "../../../redux/reducer/promotionReducer";
import { useDispatch, useSelector } from "react-redux";

const { RangePicker } = DatePicker;

export default function SentHeader() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { width } = useWindowDimensions();

  const { date: searchDate } = useSelector((state) => state.promotion);
  const [searchDisplay, setSearchDisplay] = useState("");

  const tabelHeaderList = [
    {
      label: "Sent at",
    },
    // {
    //     label: 'Unit Price',
    //     sub_label: 'Price'
    // },
    {
      label: "Sent to",
    },
    {
      label: "Voucher",
    },
    {
      label: "Used at",
    },
  ];

  const handleDateChange = (date, dateString) => {
    dispatch(setActivePage(0));

    if (date?.length > 0) {
      if (date[0].isValid() && date[1].isValid()) {
        dispatch(setDate([dateString[0], dateString[1]]));
      }
    } else {
      dispatch(setDate([]));
    }
  };

  return (
    <section className="sent-header">
      <article>
        <article className="flex flex-wrap justify-between items-center">
          <h5>Sent History</h5>
          <section
            className={`relative ${width < 820 ? "w-100 ps-4 pe-4" : ""}`}
          >
            <article className="search-bar">
              <RangePicker
                value={
                  searchDate?.length > 0
                    ? [dayjs(searchDate[0]), dayjs(searchDate[1])]
                    : []
                }
                onChange={(date, dateString) => {
                  handleDateChange(date, dateString);
                }}
                popupClassName={width < 550 ? "dateRangePicker" : undefined}
              />
              <section className="search-divider" />
              <section className="flex w-100">
                <input
                  value={searchDisplay}
                  placeholder="Search something.."
                  onChange={(e) => setSearchDisplay(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      dispatch(setSearch(searchDisplay));
                      dispatch(setActivePage(0));
                    }
                  }}
                />
                <Button
                  onClick={() => {
                    dispatch(setSearch(searchDisplay));
                    dispatch(setActivePage(0));
                  }}
                >
                  <Icon icon="majesticons:search-line" />
                  <p>Search</p>
                </Button>
              </section>
            </article>
          </section>
        </article>
        <hr />
        <section className="header-list">
          {tabelHeaderList.map((header, headerIndex) => (
            <p key={headerIndex}>{header.label}</p>
          ))}
        </section>
      </article>
    </section>
  );
}
